export enum UnmappedStopStatusCode {
  SEARCHING = 'searching',
  SEARCHING_ERROR = 'searching-error',
  SEARCHING_SUCCESS = 'searching-success',
  SAVING = 'saving',
  SAVING_ERROR = 'saving-error',
  SAVING_SUCCESS = 'saving-success',
}
